import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getTrialStatus } from '../../services/api';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { tokens } from '../../theme';

// The free trial's notice (K11.1 pt 1.2): a quiet grey line on the first page after each sign-in, 'Free trial: N days
// left', with an x that closes it until the next sign-in; in the trial's last 3 days, amber on every page. Which sign-in
// it last showed for (trial-status's signIn), on which page, and whether it was closed, stay in the browser; a copy in
// memory covers a browser that keeps nothing, so the notice still shows on the first page only.
const NOTICE_KEY = 'beetsol.trialNotice';
let noticeMemory = {};
const readNotice = () => {
  try {
    return JSON.parse(localStorage.getItem(NOTICE_KEY)) || noticeMemory;
  } catch {
    return noticeMemory;
  }
};
const writeNotice = (notice) => {
  noticeMemory = notice;
  try {
    localStorage.setItem(NOTICE_KEY, JSON.stringify(notice));
  } catch {
    // kept in memory only
  }
};

function Footer() {
  const [trialInfo, setTrialInfo] = useState(null);
  const [, setClosedNow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    getTrialStatus().then(res => setTrialInfo(res.data));
  }, []);

  const onTrial = !!trialInfo && trialInfo.instanceType === 'FREE_TRIAL' && !trialInfo.expired;
  const lastDays = onTrial && trialInfo.daysLeft <= 3;
  const notice = onTrial ? readNotice() : {};
  const newSignIn = onTrial && notice.signIn !== trialInfo.signIn;
  const firstPage = onTrial && (newSignIn || (!notice.closed && notice.page === pathname));
  const showNotice = lastDays || firstPage;

  // The first page after a sign-in is recorded, and leaving it closes the notice until the next sign-in.
  useEffect(() => {
    if (!onTrial) return;
    const seen = readNotice();
    if (seen.signIn !== trialInfo.signIn) writeNotice({ signIn: trialInfo.signIn, page: pathname, closed: false });
    else if (!seen.closed && seen.page !== pathname) writeNotice({ ...seen, closed: true });
  }, [onTrial, trialInfo, pathname]);

  const closeNotice = () => {
    writeNotice({ signIn: trialInfo.signIn, page: pathname, closed: true });
    setClosedNow(true);
  };

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        //backgroundColor: 'background.paper',
        // borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
        position: 'relative',
        zIndex: 10,
      }}
    >
      {/*  
            <footer className="main-footer">
                <center>© Beetsol</center>
            </footer>
            */}
      <div id="myModal" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false"></div>

      {/* Include necessary scripts */}
      <script src="/plugins/datatables/jquery.dataTables.min.js"></script>
      <script src="/plugins/datatables/dataTables.buttons.min.js"></script>
      <script src="/plugins/datatables/buttons.flash.min.js"></script>
      <script src="/plugins/datatables/buttons.html5.min.js"></script>
      <script src="/plugins/datatables/jszip.min.js"></script>
      {/* <script src="/adminlte/js/adminlte.min.js"></script> */}
      {/* Add other scripts as needed */}

      {/* ...other footer content... */}
      {/* Removed 2 Nov 2026 (K11.1 pt 1.2): 'Trial expires in N days' as an amber warning with an icon on every page,
          for the whole trial. */}
      {showNotice && (
        <Box
          data-testid="trial-notice"
          sx={{
            mt: 1,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            ...(lastDays ? { background: tokens.color.status.warnBg, borderRadius: tokens.radius.sm, px: '12px', py: '4px' } : {}),
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: lastDays ? tokens.color.status.warnText : tokens.color.textSecondary,
              fontFamily: tokens.font.family,
              fontSize: tokens.font.size.sm,
            }}
          >
            Free trial: {trialInfo.daysLeft} day{trialInfo.daysLeft !== 1 ? 's' : ''} left
          </Typography>
          {!lastDays && (
            <IconButton size="small" aria-label="Close" onClick={closeNotice} sx={{ color: tokens.color.textSecondary, p: '2px' }}>
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
}

export default Footer;
